import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Grid, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"
import CustomButton from "../../components/custom-button/custom-button.component"
import { Fade } from "react-awesome-reveal"
import { Link } from "react-scroll"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"
import Slider from "react-slick"

export const Wrapper = styled(SectionWrapper)`
  background-color: ${({ theme }) => theme.palette.secondary.light};
  padding: 1.5rem 0 3.5rem 0;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 5rem 0;
  }
`

export const CustomGrid = styled(Grid)`
  align-items: flex-end;
  margin-top: -6rem;
`

export const ExtraTitle = styled.h2`
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette.primary.main};
  font-style: normal;
  font-weight: 600;
  font-size: ${({ theme }) => theme.typography.pxToRem(12)};
  line-height: 15px;
  letter-spacing: 0.05em;
  text-align: center;
  margin-bottom: 0.75rem;
  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-top: 2em;
  }
`

export const Title = styled.h1`
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.palette.text.primary};
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.typography.pxToRem(32)};
  line-height: 48px;
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.dark};
  padding-bottom: 1.25rem;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(48)};
    line-height: 58px;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(60)};
    line-height: 72px;
    max-width: 604px;
    margin: auto;
  }
`

export const Paragraph = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.content};
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  line-height: 21px;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 314px;
    margin: auto;
  }
`

export const WrapperLeft = styled.div`
  display: flex !important;
  flex-direction: column;
  height: 100%;
  //justify-content: center;
  //width: 100%;
`

export const TextWrapper = styled.div`
  max-width: 325px;
`

export const Button = styled(CustomButton)`
  margin-top: 2rem;
  max-width: 165px;
`

export const ButtonSmoothly = styled(Link)`
  color: white;
  margin-top: 2rem;
  max-width: 165px;
  background-color: ${({ theme }) => theme.palette.primary.main};
  padding: 0.5em 1.5em;
  border: 1px solid transparent;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  font-weight: 400 !important;
  border-radius: 100px;
  line-height: 19px;
  text-transform: unset;
  cursor: pointer;
  text-align: center;

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 1em 2em;
  }
`

export const ImagesWrapper = styled.div`
  position: relative;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  border: 0.2px solid rgba(0, 73, 20, 0.25);
  &.space {
    flex: 1;
    margin-bottom: 0.75rem;
  }
  :not(&.space) {
    height: 100%;
  }
  :not(&.space),
  &.yellow,
  &.green {
    img {
      object-fit: cover !important;
    }
  }
  &.space&.dark-green {
    display: flex;
    padding: 1rem 1.5rem 0 0;
    img {
      object-fit: contain !important;
      margin-top: auto;
      object-position: bottom;
    }
  }
  &.green {
    max-height: 310px;
  }
  &.yellow {
    padding: 3rem 0 2rem 1rem;
  }
  &.yellow,
  &.dark-green&.space {
    max-height: 370px;
  }
  a {
    font-weight: 600;
    font-size: 0.75rem;
    line-height: 15px;
    text-align: center;
    text-decoration: underline;
    color: ${({ theme }) => theme.palette.primary.main};
    margin-top: 2rem;
    margin-left: -1rem;
    text-transform: uppercase;
    display: block;
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    &.space {
      flex: unset;
      height: 280px;
    }
    &.space&.dark-green {
      padding: 2rem 1.5rem 0 0;
    }
  }
  ${({ theme }) => theme.breakpoints.up("lg")} {
    &.space {
      height: 370px;
    }
  }
`
export const Card = styled(CustomBgImage)`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  min-height: 120px;
  color: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &.dark-green {
    justify-content: flex-end;
    //padding: 18px 0.75rem;
    img {
      object-fit: cover !important;
    }
  }
  &.yellow {
    padding: 1rem;
    background-color: ${({ theme }) => theme.palette.tertiary.dark};
  }
  &.green {
    padding: 1rem;
    background-color: ${({ theme }) => theme.palette.secondary.dark};
    color: #113225;
    text-align: center;
  }
  .circle {
    width: 100%;
    max-width: 60px;
    min-width: 40px;
    ${({ theme }) => theme.breakpoints.down("sm")} {
      margin: auto;
    }
  }
  .MuiGrid-item {
    display: flex;
    align-items: center;
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    min-height: 145px;
  }
  ${({ theme }) => theme.breakpoints.up("lg")} {
    &.yellow {
      padding: 2.75rem;
    }
    &.green {
      padding: 2.75rem 1rem 1rem;
    }
  }
`

export const BackgroundCircle = styled(CustomImage)`
  position: relative;
`

export const BgFade = styled(Fade)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

export const BackgroundImage = styled(CustomImage)`
  width: 100%;
  height: 100%;
  &.yellow {
    max-height: 242px;
    img {
      object-position: bottom left;
    }
  }
`
export const CardTitle = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 1.75rem;
  font-weight: 400;
  line-height: 2rem;
  max-width: 209px;

  &.dark-green {
    font-size: 1.25rem;
    line-height: 28px;
    margin: 0.75rem 1.75rem;
  }
  &.green {
    margin-bottom: 1.5rem;
  }
  ${({ theme }) => theme.breakpoints.up("sm")} {
    margin: auto;
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    &.green {
      margin-bottom: 3.5rem;
    }
  }
`
export const CustomLink = styled(Link)`
  cursor: pointer;
`
export const Arrow = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.main};
  border-radius: 100px;
  padding: 0.75rem;
  max-height: 44px;
  max-width: 44px;
  svg {
    width: 20px;
    height: 20px;
    color: white;
  }
`
export const CustomSlider = styled(Slider)`
  margin-top: 1.75rem;
  margin-right: 1rem;
  .slick-track {
    display: flex !important;
    //padding-right: 3rem;
  }
  .slick-list {
    overflow: visible;
  }
  .slick-slide {
    height: inherit !important;
    > div:first-child {
      height: 100%;
      margin: 0 10px;
    }
  }
`
export const SliderWrapper = styled.div`
  //margin-left: 1.5rem;
  //height: 430px;
`
